import { useState, useRef } from 'react';
import HeadingTextSolid from '@simplywallst/ui-core/icons/HeadingTextSolid';
import { ToggleButton } from '@simplywallst/ui-core';
import { useClickOutside } from '@/hooks/useClickOutside';
import { isDisabled } from '@components/RichTextEditor/utils';
import { FormatType } from '@components/RichTextEditor';

interface Props {
  format: (formatType: FormatType) => void;
  isActive: (formatType: FormatType) => boolean | undefined;
}

export const Heading = ({ format, isActive }: Props) => {
  const [showingPanel, setShowingPanel] = useState(false);
  const componentRef = useRef(null);
  const buttonRef = useRef(null);
  useClickOutside([componentRef, buttonRef], () => {
    setShowingPanel(false);
  });

  return (
    <div className="relative">
      <ToggleButton
        aria-label="Toggle heading panel"
        ref={buttonRef}
        styleType="subtle"
        onClick={() => {
          setShowingPanel(!showingPanel);
        }}
        disabled={isDisabled(['bulletList', 'orderedList'], isActive)}
        state={
          showingPanel ||
          isActive('heading1') ||
          isActive('heading2') ||
          isActive('heading3')
            ? 'on'
            : 'off'
        }
      >
        <HeadingTextSolid />
      </ToggleButton>
      {showingPanel && (
        <div
          className="absolute left-0 bottom-x7 bg-p-grey-50 px-x1_5 py-x1 rounded-x1 shadow-border-subtle"
          ref={componentRef}
        >
          <div className="grid grid-cols-[repeat(3,max-content)] gap-x1_5">
            {[1, 2, 3].map((item) => (
              <ToggleButton
                key={`heading${item}`}
                styleType="subtle"
                onClick={() => format(`heading${item}` as FormatType)}
                state={isActive(`heading${item}` as FormatType) ? 'on' : 'off'}
                aria-pressed={isActive(`heading${item}` as FormatType)}
                className="!text-xs"
              >
                {`H${item}`}
              </ToggleButton>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
